import Vue from "vue";
import * as Api from "../../api";
import Utils from "../../untils";

const state = {}

const getters = {}

const mutations = {}

const actions = {
  getAllFaqByPage({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/oa/faq/all/faq/${params.page}/${params.size}`,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getAllFaqListByPageCallback");
      }
    });
  },
  getAllFaqList({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/oa/faq/all/faq`,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getAllFaqListCallback");
      }
    });
  },
  getFaqById({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/oa/faq/faq/${params.faqId}`,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getFaqByIdCallback");
      }
    });
  },
  saveFaq({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/oa/faq/faq`,
      ...params
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "saveFaqCallback");
      }
    });
  },
  updateFaq({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/oa/faq/faq`,
      ...params
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "updateFaqCallback");
      }
    });
  },
  deleteFaq({ state, rootState }, { params, callback }) {
    console.log('deleteFaq: ', params)
    let obj = {
      action: `/oa/faq/faq/${params.faqId}`,
      ...params
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteFaqCallback");
      }
    });
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/faq.js